import { bl_sfa_qualification_criteria_set_RowClass as bl_sfa_qualification_criteria_set_RowClass } from "../../dbschema/bl_sfa_qualification_criteria_set.model";
import { BaseContainerModel } from "../base-container.model";

export class SfaQualificationCriteriaSetContainerModel extends BaseContainerModel {
	bl_sfa_qualification_criteria_set: bl_sfa_qualification_criteria_set_RowClass =
		new bl_sfa_qualification_criteria_set_RowClass();
}
